export const isMobile = () =>
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLowerCase()
  )

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
